var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSignalWifiOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.64 5.99994C23.19 5.65994 18.71 1.99994 12 1.99994C10.5 1.99994 9.10999 2.18994 7.84999 2.47994L18.18 12.7999L23.64 5.99994ZM17.04 14.2199L3.26999 0.439941L1.99999 1.71994L4.04999 3.77994C1.90999 4.75994 0.589985 5.81994 0.359985 5.99994L11.99 20.4899L12 20.4999L12.01 20.4899L15.91 15.6299L19.23 18.9499L20.5 17.6799L17.04 14.2199Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalWifiOff);
export default __webpack_public_path__ + "static/media/signal_wifi_off.22a89680d0b2f2aa6bd2e61345de3ba1.svg";
export { ForwardRef as ReactComponent };